import script from "./PrayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayPage.vue?vue&type=script&setup=true&lang=js"

import "./PrayPage.vue?vue&type=style&index=0&id=c50eb8ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c50eb8ba"]])

export default __exports__